import { BrowserRouter as Router } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "../../common/msalConfig";
import { useEffect } from "react";

import MainComponent from "./MainComponent";

/**
 * RootComponent
 *
 * This component serves as the root wrapper of the entire application.
 * It provides the following contexts to all child components:
 *
 * - MSAL Authentication Context (`MsalProvider`) — enables Microsoft SSO and token management.
 * - React Router Context (`BrowserRouter`) — enables SPA routing throughout the application.
 *
 * @param {Object} props - Props passed down to MainComponent.
 * @returns {JSX.Element} A React component tree wrapped with auth and routing providers.
 */
export default function RootComponent(props) {
  // Handle redirect promise on mount to capture auth code/token
  useEffect(() => {
    msalInstance.handleRedirectPromise()
      .then((response) => {
        if (response) {
          console.log("Redirect response received:", response);
          // Set the active account
          msalInstance.setActiveAccount(response.account);
        }
      })
      .catch((error) => {
        console.error("Error handling redirect:", error);
      });
  }, []);

  return (
    // Provides MSAL authentication instance to the app
    <MsalProvider instance={msalInstance}>
      {/* Enables client-side routing */}
      <Router>
        {/* Main app logic and routing defined here */}
        <MainComponent {...props} />
      </Router>
    </MsalProvider>
  );
}
